

<template>
  <div class="form-floating mb-3">
    <select
      class="form-select"
      id="floatingSelect"
      :value="safeModelValue.cause"
      @change="onCauseChange"
    >
      <option disabled value="">Selecione a causa</option>
      <option value="780">780 - (FALH TRANSP OPE) - Falha transporte operadora/parceiro</option>
      <option value="781">781 - (FALH OP TRANSIT) - Falha operadora trânsito</option>
      <option value="185">185 - (REPARO FIELD) - Necessidade de reparo em campo</option>
    </select>
    <label for="floatingSelect">Causa</label>
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from 'vue';

import { computed } from 'vue';
const props = defineProps({
  modelValue: {
    type: Object,
    required: false,
    default: undefined
  }
});
const emit = defineEmits(['update:modelValue']);

const safeModelValue = computed(() => {
  return props.modelValue && typeof props.modelValue === 'object'
    ? { ...props.modelValue, cause: props.modelValue.cause || '' }
    : { cause: '' };
});

function onCauseChange(event: Event) {
  const value = (event.target as HTMLSelectElement).value;
  emit('update:modelValue', { ...safeModelValue.value, cause: value });
}
</script>

<style scoped>
.edited-message {
  height: 75px !important;
  overflow: auto;
}
</style>
